export default "__VITE_ASSET__De3qg5q0__"